// Newsletter ads reported by Newsdesk (backend/newsdesk_link.py).
// A booking is "sent" only when Newsdesk confirmed the newsletter went
// out: `newsletter_sent_at` ("YYYY-MM-DD"). Pure helpers, no React.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// "2026-10-12" -> "Oct 12, 2026". Parsed by hand: new Date("2026-10-12")
// is UTC midnight and shows as the 11th in Baja.
export function formatDay(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
  if (!m) return '';
  const month = MONTHS[Number(m[2]) - 1];
  return month ? `${month} ${Number(m[3])}, ${m[1]}` : '';
}

export function isSent(booking) {
  return !!(booking && booking.newsletter_sent_at);
}

// Digital (website-category) bookings are the ones that can be marked
// as sent, by Newsdesk or by hand.
export function canMarkSent(booking) {
  return !!(booking && booking.id && booking.category === 'website' && booking.status !== 'cancelled');
}

// Date offered in "Mark as sent": the booking's own date, else today
// (local calendar day, built by hand so it never shifts).
export function defaultSentDay(booking, now = new Date()) {
  const own = booking && booking.digital_start_date;
  if (/^\d{4}-\d{2}-\d{2}$/.test(String(own || ''))) return own;
  const pad = (n) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

// { sent, sentDay, subject, movedFrom, byNewsdesk, manual, markedBy } or
// null when the booking was never marked sent nor created by Newsdesk.
export function newsdeskInfo(booking) {
  if (!booking) return null;
  const sent = isSent(booking);
  const byNewsdesk = !!booking.created_by_newsdesk;
  if (!sent && !byNewsdesk) return null;
  const moved = booking.newsletter_original_date;
  return {
    sent,
    sentDay: sent ? formatDay(booking.newsletter_sent_at) : '',
    subject: (sent ? booking.newsletter_sent_subject : booking.newsdesk_subject) || '',
    movedFrom: sent && moved && moved !== booking.newsletter_sent_at ? formatDay(moved) : '',
    byNewsdesk,
    manual: sent && !!booking.newsletter_sent_manual,
    markedBy: sent && booking.newsletter_sent_manual ? booking.newsletter_sent_by || '' : '',
  };
}
